export default __webpack_public_path__ + "static/media/icon_subject.4f504cbc.svg";